import { render, staticRenderFns } from "./ChevronSvg.vue?vue&type=template&id=db7da6b8&"
import script from "./ChevronSvg.vue?vue&type=script&lang=ts&"
export * from "./ChevronSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('db7da6b8', component.options)
    } else {
      api.reload('db7da6b8', component.options)
    }
    module.hot.accept("./ChevronSvg.vue?vue&type=template&id=db7da6b8&", function () {
      api.rerender('db7da6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/ChevronSvg.vue"
export default component.exports